import BaseList from 'records/BaseList';
import { Recipes } from 'records/Recipe';
import { List } from 'immutable';

import {
  BATCH_RECIPES_ASYNC_ACTION_START,
  BATCH_RECIPES_ASYNC_ACTION_ERROR,
  BATCH_RECIPES_ASYNC_UPDATE_ACTION_SUCCESS,
  BATCH_RECIPES_RESET_STATE,
} from 'actions/batchrecipes';

const initialState = new BaseList({
  loading: false,
  errorMessage: null,
  data: new List(),
});

const actionsMap = {
  [BATCH_RECIPES_ASYNC_ACTION_START]: (state) => {
    return state.merge({
      loading: true,
      errorMessage: null,
    });
  },
  [BATCH_RECIPES_ASYNC_ACTION_ERROR]: (state, action) => {
    return state.merge({
      loading: false,
      errorMessage: action.error,
    });
  },
  [BATCH_RECIPES_ASYNC_UPDATE_ACTION_SUCCESS]: (state, action) => {
    const recipesData = Recipes(action.data);
    return state.merge({
      loading: false,
      errorMessage: null,
      data: recipesData,
    });
  },
  [BATCH_RECIPES_RESET_STATE]: () => {
    return initialState;
  },
};

export default function batchrecipes(state = initialState, action = {}) {
  const fn = actionsMap[action.type];
  return fn ? fn(state, action) : state;
}
